import { RESPONSIVE_BREAKPOINT } from "@/utils/constants";
import styled from "styled-components";

const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 24px;

  .ant-btn {
    flex: 1;
    height: 44px;
  }
  
  @media (max-width: ${RESPONSIVE_BREAKPOINT}) {
    flex-direction: column;
    
    .ant-btn {
      width: 100%;
      flex: none;
    }
  }
`;

export default ButtonGroup;